<template>
  <div id="join-form" class="modal-form">
    <div class="container bg-white">
      <p class="text-primary h4">Join Contest</p>
      <p class="text-body">
        You are joining this contest with [Experience name]. Once, the contest
        organizer approves your participation. To get the most out of the
        contest, we recomment to promote it to your customers asking them to
        also add your experience hashtag to their submissions.
      </p>
      <div class="d-flex justify-content-between">
        <button @click="close" class="btn btn-primary">JOIN WITH ANOTHER EXPERIENCE</button>
        <button @click="close" class="btn">CLOSE</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    campaignId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      experienceId: "",
      formData: {
        name: "",
        description: "",
        sponsor: "",
        value: 0,
        valueCurrency: "USD",
        images: undefined,
      },
      experience: [],
    };
  },
  methods: {
      close() {
          this.$emit("close");
      }
  },
};
</script>

<style lang="scss">
$main-color: #1da1f2;

#join-form {
  .close-button {
    margin-bottom: 20px;
    float: right;
  }

  .container {
    max-width: 670px;
  }

  .form-title {
    color: $main-color;
  }

  .form-label {
    color: #000;
  }

  h2,
  h3 {
    margin: 0 0 0.5em;
  }

  form {
    background-color: #fff;
    padding: 30px;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16);
    color: #000;
  }

  .form-actions {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
  }

  .btn {
    min-width: 150px;
  }

  .btn-primary {
    background-color: $main-color;
  }

  .ew-file-uploader .label {
    display: none;
  }

  .form-check-label {
    line-height: 22px;
  }
}
</style>
